import React, { useEffect } from 'react';
import './PaymentMethod.scss';
import { useSelector, useDispatch, connect } from 'react-redux';
import { State } from '../../../store/interfaces';
import {
  paymentModes,
  actions as paymentActions,
} from '../../../store/reducers/payment';
import { PaymentMessage } from '../../../models/payment';
import { ContainerLoader } from '../../../components/loader';
import { useHistory } from 'react-router';
import { RouteKeys } from '../../route-keys';
import { MessageType } from '../../../models/messages';
import api from '../../../api';
import { toastr } from 'react-redux-toastr';

interface CustomProps {
  gotoPreviousBlock?: () => void;
  selectedAddOn?: any;
  user?: any;
  paymentMethod: paymentModes;
  totalAmount?: number;
  referralAmount?: number;
}

const PaymentRedirectLink: React.SFC<CustomProps> = (props: CustomProps) => {
  const selectedLanguage = useSelector((state: any) => state.language.selectedLanguage);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchPaymentStatus = async () => {
      const params = new URLSearchParams(window.location.search);
      const payload = {
        order_id: params.get('order_id'),
        tracking_id: params.get('tracking_id')       
      };

      try {
        const response = await api.payment.verifyPaymentLink({ trackingId: payload.order_id });

        const status = response.data.status;
        const onlinePaymentStatus = status  
        if (onlinePaymentStatus ==='success') {
          const paymentResponse = await api.payment.verifyPaymentLinkApi(response.data);
         if(paymentResponse) {
          history.replace(RouteKeys.PaymentThankYouLink);
         } else {
          history.replace(RouteKeys.PaymentErrorLink);
         }
        } else if  (onlinePaymentStatus ==='cancelled'){
          history.replace(RouteKeys.PaymentCancelledLink);
        } else {
         history.replace(RouteKeys.PaymentErrorLink);
        }
      } catch (error) {
        toastr.error('Error','Error verifying payment:');
        history.replace(RouteKeys.PaymentErrorLink);
      }
    };

    fetchPaymentStatus();
  }, []);

  return (
    <div className="PaymentMethod">
      <ContainerLoader
        height={800}
        text="Payment in progress, please do not close or click the back button..."
      />
    </div>
  );
};


const mapStateToProps = (state: State) => ({
  selectedAddOn: state.payment.currectAddOn,
  user: state.authUser,
  paymentMethod: state.payment.modeOfPayment,
  totalAmount: state.payment.summary.totalAmountPaid,
  referralAmount: state.registration?.referralAmount || 0,
});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentRedirectLink);
